import $ from 'jquery'
import Fuse from 'fuse.js'
import Cookies from 'js-cookie'
//import { get_state_name } from './modules/_state-abbreviation'
import { add_region_polygon } from './modules/_property_map_region_coordinates'
import { __ } from '@wordpress/i18n'

$(document).ready(function () {
	$('#propertytype-select').select2({
		//dropdownParent: $('#wrapper'),
		placeholder: 'Property Type',
		tags: true,
	})
})

const currency = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
})

function init() {
	const propert_data = $.getJSON('/wp-content/api-cache/properties-data.json')

	$.when(propert_data)
		.done(function (properties) {
			//console.log('properties? ', properties)
			generate_map(properties)
		})
		.fail(function (error) {
			// eslint-disable-next-line no-console
			console.error('error', error)
		})
}

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
}

function set_map(map, bounds) {
	map.initialZoom = true

	if (window.innerWidth <= 1031) {
		map.fitBounds(bounds, 20)
	} else {
		map.fitBounds(bounds, 100)
	}

	// window.google.maps.event.addDomListener(window, 'resize', function () {
	// 	map.fitBounds(bounds)
	// 	map.initialZoom = true
	// })
}

function get_property_listing_template(property) {
	//console.log('property? ', property)
	const property_price = property.price ? currency.format(property.price) : ''
	let property_price_with_status

	if (true === property.hide_price || !null === property.hide_price) {
		property_price_with_status = ''
	} else {
		property_price_with_status = property_price
	}

	const under_contract =
		property.rr_under_contract && !property.sold.length
			? '<p class="properties-map__contract">Under Contract</p>'
			: ''

	const is_sold = property.sold.length ? '<p class="properties-map__sold properties-map__contract">Sold</p>' : ''

	const property_acres = property.acres
		? `${property.acres}${property.acre_comment} ${__('Acres', 'wp_foundation_six')}`
		: property.acre_comment

	const property_image = property.featured_media ? new URL(property.featured_media) : ''

	const propery_img_tag = property_image.pathname
		? property_image.pathname
		: window.theme_path.path + '/assets/images/placeholder.svg'

	//const states = property.states.length ? property.states.map(state => get_state_name(state.name)).join(', ') : ''

	//const sub_division = states.search('LA') ? __('County', 'wp_foundation_six') : __('Parish', 'wp_foundation_six')

	const sub_division = __('County', 'wp_foundation_six')

	const counties = property.counties.length
		? property.counties.map(county => county.name + ' ' + sub_division).join(', ') + ', '
		: ''

	//const city = property.city ? property.city + ', ' : ''
	const city = property.cities.length ? property.cities.map(city => city.name).join(', ') : ''

	const is_fay_ranches = property.regions.filter(region => region.slug === 'fay-ranches')

	const fay_ranches_logo = is_fay_ranches.length
		? `<img
			class="properties-map__callout-image"
			src="${window.theme_path.path}/assets/images/fay-ranches.svg?v2"
			alt="Fay Ranches"
		>`
		: ''

	const is_featured =
		property.featured && !is_fay_ranches.length
			? `<p class="properties-map__featured">${__('Featured Property')}</p>`
			: ''

	return `<div class="properties-map__listing-item" id="property_${property.id}_js" data-property="${property.id}">
		<a class="properties-map__image-anchor" href="${property.link}">
			<div class="properties-map__image" style="background-image: url('${propery_img_tag}')">
				${fay_ranches_logo}
				${is_featured}
				${under_contract}
				${is_sold}
			</div>
		</a>
		<h2 class="properties-map__title">
			<a class="properties-map__title-anchor" href="${property.link}">
				${property.title.rendered}
			</a>
		</h2>
		<p class="properties-map__location">${counties + city}</p>
		<p class="properties-map__price">
			${property_price_with_status}
			${property.price_comment}
		</p>
		<p class="properties-map__acres">${property_acres}</p>
		<span class="properties-map__summary">${property.summary}</span>
		<p class="properties-map__button">
			<a href="${property.link}" class="button secondary">${__('View Property', 'wp_foundation_six')}</a>
		</p>
	</div>`
}

function filter_property_list(markers, bounds) {
	if (!markers.length) {
		return
	}

	$('#property_list_js').find('.properties-map__listing-item').css('display', 'none')

	markers.map(marker => {
		marker.setVisible(true)
		bounds.extend(marker.getPosition())
		$('#property_list_js').find(`[id="property_${marker.property.id}_js"]`).css('display', '')
	})
}

function get_info_window_template(property) {
	const property_price = property.price ? currency.format(property.price) : ''
	let property_price_with_status

	if (true === property.hide_price || !null === property.hide_price) {
		property_price_with_status = ''
	} else {
		property_price_with_status = property_price
	}

	const property_acres = property.acres ? `${property.acres}${property.acre_comment} Acres` : property.acre_comment

	const property_image = property.featured_media ? new URL(property.featured_media) : ''

	const propery_img_tag = property_image.pathname
		? property_image.pathname
		: window.theme_path.path + '/assets/images/placeholder.svg'

	const location = []

	property.counties.length ? location.push(property.counties.map(county => county.name + ' County').join(', ')) : ''
	//property.city ? location.push(property.city) : ''
	property.cities.length ? location.push(property.cities.map(city => city.name).join(', ')) : ''
	//property.states.length ? location.push(property.states.map(state => get_state_name(state.name)).join(', ')) : ''

	return `<div class="info-window-container">
		<a class="info-window-container__link" href="${property.link}">
			<div class="info-window-container__image" style="background-image: url('${propery_img_tag}')"></div>
		</a>

		<p class="info-window-container__title">
			<a class="info-window-container__title-anchor" href="${property.link}"><strong>${property.title.rendered}</strong></a>
		</p>
		<p class="info-window-container__location">${location.join(', ')}</p>
		<p class="info-window-container__price">${property_price_with_status} ${property.price_comment}</p>
		<p class="info-window-container__acres">${property_acres}</p>

		<p class="info-window-container__cta">
			<a class="button secondary expanded" href="${property.link}">
				${__('View Property', 'wp_foundation_six')}
			</a>
		</p>
	</div>`
}

/**
 * Opens the property info window when property is hovered over.
 *
 * @param {object} target The element that will trigger event.
 * @param {object} map The google map instance.
 * @param {object} markers The map markers to be interted over.
 * @param {object} properties The list of unsold properties pulled from the API.
 * @param {object} infowindow The info window instance.
 */
function trigger_property_info_window(target, map, markers, properties, infowindow) {
	setTimeout(() => {
		const property_id = $(target).data('property')

		markers.map(marker => {
			if (marker.propertyID === property_id) {
				for (const index in properties) {
					if (properties[index].id === marker.propertyID) {
						const layout = get_info_window_template(properties[index])
						// map.panTo(marker.getPosition())

						infowindow.setContent(layout)
						infowindow.open(map, marker)
					}
				}
			}
		})
	}, 30)
}

function set_query_options() {
	let search = Object.fromEntries(new URLSearchParams(location.search))

	if (!Object.keys(search).length) {
		const get_search_cookies = Cookies.get('property-map-filters')
		search = Object.fromEntries(new URLSearchParams(get_search_cookies))
	}

	/* if (search.state !== 'select' && search.state !== undefined && search.state !== '' && search.state !== null) {
		$('#state-select').val(search.state).trigger('change')
	} */

	if (search.city !== 'select' && search.city !== undefined && search.city !== '' && search.city !== null) {
		$('#city-select').val(search.city).trigger('change')
	}

	if (
		search.transactiontype !== 'select' &&
		search.transactiontype !== undefined &&
		search.transactiontype !== '' &&
		search.transactiontype !== null
	) {
		$('#transactiontype-select').val(search.transactiontype).trigger('change')
	}

	if (
		search.propertytype !== 'select' &&
		search.propertytype !== undefined &&
		search.propertytype !== '' &&
		search.propertytype !== null
	) {
		$('#propertytype-select').val(search.propertytype).trigger('change')
	}

	if (search.region !== 'select' && search.region !== undefined && search.region !== '' && search.region !== null) {
		$('#region-select').val(search.region).trigger('change')
	}

	if (search.county !== 'select' && search.county !== undefined && search.county !== '' && search.county !== null) {
		$('#county-select').val(search.county).trigger('change')
	}

	if (search.order !== 'select' && search.order !== undefined && search.order !== '' && search.order !== null) {
		$('#order-select').val(search.order).trigger('change')
	}

	if (search.search !== 'select' && search.search !== undefined && search.search !== '' && search.search !== null) {
		$('#search').val(search.search).trigger('keyup')
	}
}

if (typeof Array.prototype.move === 'undefined') {
	Array.prototype.move = function (from, to, on = 1) {
		return this.splice(to, 0, ...this.splice(from, on)), this
	}
}

function generate_map(properties) {
	//UPDATE 8/3/2023 - ADD MAP TO SOLD PROPERTIES PAGE
	const pathname = window.location.pathname
	//console.log('pathname? ', pathname)
	if (pathname == '/select-sold-properties/') {
		//if we are on the sold properties page, show all sold properties
		properties = properties.filter(property => property.sold.length)
	} else {
		//if we are on the regular properties page, show all unsold properties and sold properties that also have show on map checked
		properties = properties.filter(
			property => !property.sold.length || (property.sold.length && property.sold_show_on_map.length)
		)
	}

	if (!properties.length) {
		//show no results message on page if filtered properties returns no results
		$('.properties-map').addClass('properties-map--no-results')
	}

	const map_element = document.getElementById('properties_map')
	const properties_map_wrapper = document.getElementById('properties_map_wrapper')
	const gestureType = isTouchDevice() ? 'cooperative' : 'greedy'

	const map = new window.google.maps.Map(map_element, {
		mapTypeControl: true,
		mapTypeControlOptions: {
			style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
			position: window.google.maps.ControlPosition.TOP_CENTER,
		},
		zoomControl: true,
		zoomControlOptions: {
			position: window.google.maps.ControlPosition.RIGHT_CENTER,
		},
		scaleControl: true,
		streetViewControl: true,
		streetViewControlOptions: {
			position: window.google.maps.ControlPosition.LEFT_TOP,
		},
		fullscreenControl: true,
		options: {
			gestureHandling: gestureType,
		},
	})

	add_region_polygon(map)

	window.google.maps.event.addListener(map, 'zoom_changed', function () {
		const zoomChangeBoundsListener = window.google.maps.event.addListener(map, 'bounds_changed', function () {
			if (this.getZoom() > 15 && this.initialZoom == true) {
				// Change max/min zoom here
				this.setZoom(15)
				this.initialZoom = false
			}
			if (this.getZoom() < 3 && this.initialZoom == true) {
				// Change max/min zoom here
				this.setZoom(3)
				this.initialZoom = false
			}
			window.google.maps.event.removeListener(zoomChangeBoundsListener)
		})
	})

	const bounds = new window.google.maps.LatLngBounds()
	const infowindow = new window.google.maps.InfoWindow()

	// Collection of map markers
	const markers = []
	/*
	const states = []
	const states_temp = []
	*/

	const cities = []
	const cities_temp = []

	const propertytypes = []
	const propertytypes_temp = []

	let listing_template = ''

	const properties_sorted = Object.keys(properties)

		.map(key => properties[key])
		.sort((a, b) => {
			//return a.featured === b.featured ? 0 : a.featured ? -1 : 1
			//per client request, add sorting so that Fay Ranches properties are ranked lower
			if (a.regions && b.regions) {
				if (
					a.regions.filter(region => region.slug === 'fay-ranches').length <
					b.regions.filter(region => region.slug === 'fay-ranches').length
				) {
					return -1
				}
				if (
					a.regions.filter(region => region.slug === 'fay-ranches').length >
					b.regions.filter(region => region.slug === 'fay-ranches').length
				) {
					return 1
				}
			}
			if (a.featured === b.featured) {
				return 0
			} else {
				if (a.featured) {
					return -1
				} else {
					return 1
				}
			}
		})

	$.each(properties_sorted, function (index, property) {
		const latlong = property.latlong ? property.latlong.split(',') : []
		const latitude = latlong[0]
		const longitude = latlong[1]

		if (latitude && longitude) {
			if (latitude >= 90 || latitude <= -90) {
				// eslint-disable-next-line no-console
				console.error(property.title.rendered + ' has an out of bounds latitude of ' + latitude + '.')
			}

			if (longitude >= 180 || longitude <= -180) {
				// eslint-disable-next-line no-console
				console.error(property.title.rendered + ' has an out of bounds longitude of ' + longitude + '.')
			}

			/*property.states.map(state => {
				if (states_temp.indexOf(state.name) == -1) {
					states_temp.push(state.name)
					states.push(state)
				}
			})*/

			property.cities.map(city => {
				if (cities_temp.indexOf(city.name) == -1) {
					cities_temp.push(city.name)
					cities.push(city)
				}
			})

			property.property_types.map(type => {
				if (propertytypes_temp.indexOf(type.name) == -1) {
					propertytypes_temp.push(type.name)
					propertytypes.push(type)
				}
			})

			const icon = {
				url: window.theme_path.path + '/assets/images/map-marker.png',
			}

			property.regions.forEach(region => {
				if (region.slug === 'fay-ranches') {
					icon.url = window.theme_path.path + '/assets/images/map-marker-fay-ranches-v3.png'
				}
			})

			icon.scaledSize = new window.google.maps.Size(30, 39)

			const marker = new window.google.maps.Marker({
				position: new window.google.maps.LatLng(latitude, longitude),
				icon: icon,
				optimized: false,
				map: map,
				propertyID: property.id,
				//states: property.states,
				transaction_type: property.transaction_type,
				cities: property.cities,
				regions: property.regions,
				counties: property.counties,
				property: property,
				property_types: property.property_types,
			})

			markers.push(marker)

			// Extend the bounds to include each marker's position
			bounds.extend(marker.position)

			listing_template += get_property_listing_template(property)

			// Add descriptions to map markers.
			window.google.maps.event.addListener(
				marker,
				'click',
				(marker => {
					return () => {
						const layout = get_info_window_template(property)
						const selected_property = document.getElementById(`property_${marker.propertyID}_js`)
						const selected_property_top = selected_property.offsetTop

						document
							.querySelectorAll('#property_list_js .properties-map__listing-item')
							.forEach(item => item.classList.remove('properties-map__listing-item--selected'))

						selected_property.classList.add('properties-map__listing-item--selected')
						document.getElementById('property_list_js').scrollTop = selected_property_top

						infowindow.setContent(layout)
						infowindow.open(map, marker)
					}
				})(marker, index)
			)
		}
	})

	// Now fit the map to the newly inclusive bounds
	set_map(map, bounds, markers)
	window.bounds = bounds
	window.filtered_markers = markers

	window.google.maps.event.addListener(map, 'bounds_changed', function () {
		const filtered_markers = []

		for (var i = markers.length, bounds = map.getBounds(); i--; ) {
			if (bounds == null) {
				break
			}

			if (bounds.contains(markers[i].getPosition()) && markers[i].getVisible()) {
				filtered_markers.push(markers[i])
			}
		}

		setTimeout(() => {
			filter_property_list(filtered_markers, bounds)
		}, 300)
	})

	/* const state_options = states
		.sort((a, b) => b.name.localeCompare(a.name))
		.sort(a => (a.term_id === 842 ? 1 : -1))
		.sort(a => (a.term_id === 563 ? -1 : 1))
		.map(state => `<option value="${state.slug}" data-display="${state.name}">${state.name}</option>`)
		.join('')

	$('#state-select').append(state_options) */

	const propertytype_options = propertytypes
		.sort((a, b) => b.name.localeCompare(a.name))
		.map(type => ({
			id: type.slug,
			text: type.name,
		}))

	//console.log('propertytype_options. ', propertytype_options)
	//$('#propertytype-select').append(propertytype_options)

	$.each(propertytype_options, function (_index, data) {
		//console.log('looping through property types, ', data)
		var newOption = new Option(data.text, data.id, false, false)
		$('#propertytype-select').append(newOption).trigger('change')
	})

	const city_options = cities
		//.sort((a, b) => b.name.localeCompare(a.name))
		.sort((a, b) => {
			if (a.name < b.name) {
				return -1
			}
			if (a.name > b.name) {
				return 1
			}
			return 0
		})
		.map(city => `<option value="${city.slug}" data-display="${city.name}">${city.name}</option>`)
		.join('')

	$('#city-select').append(city_options)

	const no_results = `<p id="no-results-message" class="properties-map__no-results-static">
		${__('No results were found', 'wp_foundation_six')}
	</p>`
	const property_list = `${no_results} <div id="property_list_js" class="properties-map__listing">${listing_template}</div>`

	$(properties_map_wrapper).after(property_list)
	$(properties_map_wrapper).after(
		`<h1 id="properties_map__page_title" class="properties-map__page-title text-center">
			${__('All Commercial Properties', 'wp_foundation_six')}
		</h1>`
	)

	// Property listing hover to show popup.
	$('.properties-map__listing-item').on('mouseenter', function (event) {
		event.preventDefault()

		trigger_property_info_window(this, map, markers, properties, infowindow)
	})

	// Prevent filter form submission.
	$('.property-map-filters').on('submit', function (event) {
		event.preventDefault()
	})

	// Switch to list mode.
	$('#display-list').on('click', function () {
		$('#display-map').removeClass('property-map-filters__button--active')
		$(this).addClass('property-map-filters__button--active')
		$('.properties-map').addClass('properties-map--list')
		$('.properties-map__listing-item').off()
		// $('#property_list_js').find('.properties-map__listing-item').css('display', 'block')

		if (window.filtered_markers) {
			filter_property_list(window.filtered_markers, window.bounds)
		} else {
			filter_property_list(markers, bounds)
		}
	})

	// Switch to map mode.
	$('#display-map').on('click', function () {
		$(this).addClass('property-map-filters__button--active')
		$('#display-list').removeClass('property-map-filters__button--active')
		$('.properties-map').removeClass('properties-map--list')
		set_map(map, window.bounds, window.filtered_markers)

		$('.properties-map__listing-item').on('mouseenter', function (event) {
			event.preventDefault()

			trigger_property_info_window(this, map, markers, properties, infowindow)
		})
	})

	// Filtering.
	$('#map-filters')
		.find('select')
		.on('change', function () {
			const selected = $(this)

			filter_map_markers(selected, markers, map, infowindow, properties)
		})

	$('#search').on('input keypress', function () {
		const selected = $(this)

		filter_map_markers(selected, markers, map, infowindow, properties)
	})

	$('#reset_filters').on('click', function (event) {
		event.preventDefault()

		$('#search').val('')
		$('#region-select').val('select')
		$('#county-select').val('select')
		$('#order-select').val('select')
		//$('#state-select').val('select').trigger('change')
		$('#city-select').val('select').trigger('change')
		$('#transactiontype-select').val('select').trigger('change')
		$('#propertytype-select').val('select').trigger('change')
	})

	set_query_options()

	// Switch to mobile mode below viewport width of 1030px.
	const width = $(window).width()

	if (1030 >= width) {
		$('#display-list').trigger('click')
	} else {
		$('#display-map').trigger('click')
	}
}

// markers, map, infowindow.
function filter_map_markers(selected, markers, map, infowindow, properties) {
	const bounds = new window.google.maps.LatLngBounds()
	//const state_select = $('#state-select')
	const city_select = $('#city-select')
	const region_select = $('#region-select')
	const transactiontype_select = $('#transactiontype-select')
	const propertytype_select = $('#propertytype-select')
	const county_select = $('#county-select')
	const order_select = $('#order-select')
	const search_field = $('#search')
	const region_parent = region_select.parent()
	const county_parent = county_select.parent()
	const field_selected = $(selected).attr('id')

	//console.log('propertytype_select? ', propertytype_select)

	infowindow.close()
	markers.map(marker => marker.setVisible(false))

	if (field_selected.match(/select/g)) {
		search_field.val('')
	}

	/* if ('state-select' === field_selected) {
		region_select.val('select')
		county_select.val('select')
		region_parent.hide()
		county_parent.hide()

		const currently_selected_state = state_select.val()

		if ('texas' === currently_selected_state) {
			region_parent.css('display', 'inherit')
		} else if ('select' !== currently_selected_state) {
			county_parent.css('display', 'inherit')
		}
	} */

	if ('city-select' === field_selected) {
		region_select.val('select')
		county_select.val('select')
		region_parent.hide()
		county_parent.hide()

		const currently_selected_city = city_select.val()

		if ('select' !== currently_selected_city) {
			county_parent.css('display', 'inherit')
		}
	}

	if ('region-select' === field_selected) {
		county_select.val('select')

		const currently_selected_region = region_select.val()

		if ('select' === currently_selected_region) {
			county_parent.hide()
		} else {
			county_parent.css('display', 'inherit')
		}
	}

	//const currently_selected_state = state_select.val()
	const currently_selected_city = city_select.val()
	const currently_selected_region = region_select.val()
	//const currently_selected_county = county_select.val()
	const currently_selected_transactiontype = transactiontype_select.val()
	const currently_selected_propertytype = propertytype_select.val()
	const currently_selected_order = order_select.val()
	const current_search_term = search_field.val()

	//console.log('currently_selected_propertytype? ', currently_selected_propertytype)

	let filtered_markers = markers
		.filter(marker => {
			//console.log('marker ? ', marker)
			// Transaction Type Option.
			if ('select' === currently_selected_transactiontype) return marker

			const matching_transactiontypes = marker.transaction_type == currently_selected_transactiontype

			//console.log('matching_transactiontypes ? ', matching_transactiontypes)

			if (!matching_transactiontypes) return

			return marker
		})
		.filter(marker => {
			// City option.
			if ('select' === currently_selected_city) return marker

			if (!marker.cities.length) return

			const matching_cities = marker.cities.filter(city => city.slug === currently_selected_city)

			//console.log('matching_cities ? ', matching_cities)

			if (!matching_cities.length) return

			return marker
		})
		.filter(marker => {
			// Property Type option.
			// console.log('currently_selected_propertytype ? ', currently_selected_propertytype)

			if ('' === currently_selected_propertytype || !currently_selected_propertytype.length) return marker

			if (!marker.property_types.length) return

			const matching_property_types = marker.property_types.filter(type =>
				currently_selected_propertytype.includes(type.slug)
			)

			if (!matching_property_types.length) return

			return marker
		})
		.sort((a, b) => {
			if ('select' === currently_selected_order) {
				//return a.property.featured === b.property.featured ? 0 : a.property.featured ? -1 : 1
				//per client request, add sorting so that Fay Ranches properties are ranked lower
				if (a.property.regions && b.property.regions) {
					if (
						a.property.regions.filter(region => region.slug === 'fay-ranches').length <
						b.property.regions.filter(region => region.slug === 'fay-ranches').length
					) {
						return -1
					}
					if (
						a.property.regions.filter(region => region.slug === 'fay-ranches').length >
						b.property.regions.filter(region => region.slug === 'fay-ranches').length
					) {
						return 1
					}
				}
				if (a.property.featured === b.property.featured) {
					return 0
				} else {
					if (a.property.featured) {
						return -1
					} else {
						return 1
					}
				}
			}

			if ('price-low-high' === currently_selected_order) {
				return a.property.price - b.property.price
			}

			if ('price-high-low' === currently_selected_order) {
				return b.property.price - a.property.price
			}

			if ('acreage-low-high' === currently_selected_order) {
				return Number(a.property.acres.replace(/,/g, '')) - Number(b.property.acres.replace(/,/g, ''))
			}

			if ('acreage-high-low' === currently_selected_order) {
				return Number(b.property.acres.replace(/,/g, '')) - Number(a.property.acres.replace(/,/g, ''))
			}
		})

	/*
	if ('state-select' === field_selected && 'texas' === currently_selected_state) {
		const regions = []
		const regions_temp = []

		filtered_markers.map(marker => {
			marker.regions.map(region => {
				if (regions_temp.indexOf(region.name) === -1) {
					regions_temp.push(region.name)
					regions.push(region)
				}
			})
		})

		const regions_options = regions
			.sort((a, b) => a.name.localeCompare(b.name))
			.map(region => `<option value="${region.slug}" data-display="${region.name}">${region.name}</option>`)

		region_select.html(
			`<option selected="selected" value="select">
				${__('Region', 'wp_foundation_six')}
			</option>
			${regions_options.join('')}`
		)
	}
	*/

	/* if (
		('region-select' === field_selected && 'select' !== currently_selected_region) ||
		('state-select' === field_selected && 'texas' !== currently_selected_state) ||
		('state-select' === field_selected && 'select' !== currently_selected_state)
	) {
		const counties = []
		const counties_temp = []

		filtered_markers.map(marker => {
			marker.counties.map(county => {
				if (counties_temp.indexOf(county.name) === -1) {
					counties_temp.push(county.name)
					counties.push(county)
				}
			})
		})

		const counties_options = counties
			.sort((a, b) => a.name.localeCompare(b.name))
			.map(county => `<option value="${county.slug}" data-display="${county.name}">${county.name}</option>`)

		county_select.html(
			`<option selected="selected" value="select">
				${__('County', 'wp_foundation_six')}
			</option>
			${counties_options.join('')}`
		)
	}
	 */

	if (current_search_term) {
		const fuse = new Fuse(filtered_markers, {
			keys: [
				'property.title.rendered',
				'property.summary',
				//'property.counties.name',
				//'property.regions.name',
				//'property.states.name',
				'property.cities.name',
				'property.property_types.name',
			],
			threshold: 0.3,
		})

		const search_results = fuse.search(current_search_term)

		filtered_markers = search_results.reduce((accumulator, currentValue, index) => {
			accumulator[index] = currentValue.item
			return accumulator
		}, [])

		//console.log('filtered markers? ', filtered_markers)
		//per client request, add sorting so that Fay Ranches properties are ranked lower
		filtered_markers = filtered_markers.sort((a, b) => {
			if (a.property.regions && b.property.regions) {
				if (
					a.property.regions.filter(region => region.slug === 'fay-ranches').length <
					b.property.regions.filter(region => region.slug === 'fay-ranches').length
				) {
					return -1
				}
				if (
					a.property.regions.filter(region => region.slug === 'fay-ranches').length >
					b.property.regions.filter(region => region.slug === 'fay-ranches').length
				) {
					return 1
				}
			}
		})
	}

	let new_property_list = ''

	filtered_markers.map(marker => {
		marker.setVisible(true)
		bounds.extend(marker.getPosition())
		new_property_list += get_property_listing_template(marker.property)
	})

	const property_list_container = $('#property_list_js')
	property_list_container.scrollTop(0)
	property_list_container.html(new_property_list)

	//console.log('filtered markers? ', filtered_markers)

	if (!filtered_markers.length) {
		$('.properties-map').addClass('properties-map--no-results')
	} else {
		$('.properties-map').removeClass('properties-map--no-results')
	}

	$('.properties-map__listing-item').on('mouseenter', function (event) {
		event.preventDefault()

		trigger_property_info_window(this, map, markers, properties, infowindow)
	})

	const params = new URLSearchParams(location.search)
	//params.set(state_select.attr('name'), currently_selected_state)
	params.set(city_select.attr('name'), currently_selected_city)
	//params.set(region_select.attr('name'), currently_selected_region)
	//params.set(county_select.attr('name'), currently_selected_county)
	params.set(transactiontype_select.attr('name'), currently_selected_transactiontype)
	params.set(propertytype_select.attr('name'), currently_selected_propertytype)
	params.set(order_select.attr('name'), currently_selected_order)
	params.set(search_field.attr('name'), current_search_term)
	const updated_query_string = window.location.pathname + '?' + params.toString()
	history.pushState(null, '', updated_query_string)
	//console.log('params ', params.toString())
	Cookies.set('property-map-filters', '?' + params.toString(), { path: '' })

	window.filtered_markers = filtered_markers
	window.bounds = bounds

	//const state_title = 'select' !== currently_selected_state ? state_select.find(':selected').data('display') : ''
	const city_title = 'select' !== currently_selected_city ? city_select.find(':selected').data('display') : ''
	const region_title = 'select' !== currently_selected_region ? region_select.find(':selected').data('display') : ''
	/* const sub_division = currently_selected_state.search('louisiana')
		? __('County', 'wp_foundation_six')
		: __('Parish', 'wp_foundation_six') */
	const county_title = ''
	/*const county_title =
		'select' !== currently_selected_county
			? county_select.find(':selected').data('display') + ' ' + sub_division
			: ''*/

	let $listing_title = ''

	//console.log('county_title ?', county_title)

	if (county_title) {
		$listing_title = county_title
	} else if (region_title) {
		$listing_title = region_title
		/* } else if (state_title) {
		$listing_title = state_title */
	} else if (city_title) {
		$listing_title = city_title
	} else {
		$listing_title = 'All'
	}

	$('#properties_map__page_title').html(`${$listing_title} ${__('Commercial Properties', 'wp_foundation_six')}`)

	set_map(map, bounds, filtered_markers)
}

init()
